<template>
  <PrintTicketLayout>
    <template v-slot:content>
      <div>
        <span style="text-transform: uppercase">{{ $t("Tarjeta fidelidad") }}</span>

        <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

        <table v-if="tarjeta_fidelidad_vendida" style="border: 0; width: 100%">
          <tbody>
          <tr>
            <td style="text-align: left; padding: 0;">{{ $t("Numeración") }}:</td>
            <td style="text-align: right; padding: 0;">{{ tarjeta_fidelidad_vendida.numeracion }}</td>
          </tr>

          <tr>
            <td style="text-align: left; padding: 0;">{{ $t("Importe usado") }}:</td>
            <td style="text-align: right; padding: 0;">{{ tarjeta_fidelidad_vendida.importe_usado | money }}</td>
          </tr>

          <tr>
            <td style="text-align: left; padding: 0;">{{ $t("Importe restante") }}:</td>
            <td style="text-align: right; padding: 0;">{{ tarjeta_fidelidad_vendida.importe_restante | money }}</td>
          </tr>

          <tr>
            <td style="text-align: left; padding: 0;">{{ $t("Fecha compra") }}:</td>
            <td style="text-align: right; padding: 0;">{{ tarjeta_fidelidad_vendida.fecha_compra | moment('DD/MM/YYYY') }}</td>
          </tr>

          <tr>
            <td style="text-align: left; padding: 0;">{{ $t("Caducidad") }}:</td>
            <td style="text-align: right; padding: 0;">
              <span v-if="tarjeta_fidelidad_vendida.fecha_caducidad"> {{ tarjeta_fidelidad_vendida.fecha_caducidad | moment('DD/MM/YYYY') }} </span>
              <span v-else>{{ $t('Sin caducidad') }}</span>
            </td>
          </tr>
          </tbody>
        </table>

      </div>
    </template>
  </PrintTicketLayout>
</template>

<script>
import UserDeviceMixin from "@/mixins/UserDeviceMixin";

export default {
  name: 'PrintTarjetaFidelidadVendida',
  mixins: [UserDeviceMixin],
  data(){
    return {
      tarjeta_fidelidad_vendida: null
    }
  },

  methods: {
    /**
     * Cargamos la cita
     * @returns {Promise<void>}
     */
    async get_tarjeta_fidelidad_vendida(){
      try{
        this.tarjeta_fidelidad_vendida = await this.$store.dispatch('tarjeta_fidelidad/get_tarjeta_fidelidad_vendida', this.$route.params.id)
      }catch (err){
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    imprimir(){
      setTimeout(() => {
        if(this.centro.is_pass_print && (['mobile', 'tablet'].includes(this.get_device()))){
          let receiptHTML='<!DOCTYPE html><html><head><title></title><meta charset="UTF-8"><meta name="viewport" content="width=576"></head><body>';
          receiptHTML+=document.getElementById("content_ticket").innerHTML;
          receiptHTML+="</body></html>"
          const receiptB64=encodeURIComponent(receiptHTML);
          location.href = "starpassprnt://v1/print/nopreview?back=null&html=" + receiptB64
        }else{
          window.print()
        }
      }, 2000)
    }
  },

  async mounted() {
    await this.get_tarjeta_fidelidad_vendida()
    this.imprimir()
  },

  components: {
    PrintTicketLayout: () => import('@/components/impresiones/PrintTicketLayout')
  }
}
</script>
